module.exports = __webpack_public_path__ + "static/media/Trevor_S.ef857a32.jpg";